import Header from '../../components/Header';
import Footer from '../../components/Footer';
import TEAM from './team.json';
import useIsMobile from '../../hook/useIsMobile';
import TeamCard from './components/TeamCard';
import CoreValueStickySection from './components/CoreValueStickySection';
import {useNavigate} from 'react-router-dom';

export default function AboutPage() {

  const isMobile = useIsMobile();
  const navigate = useNavigate();

  return (
    <div>
      <Header/>
      <main>
        <section
          data-bg-type='colorful'
          className='relative w-full h-screen flex flex-col justify-center items-center text-center text-white text-title2 lg:text-display1'
        >
          <img
            className='absolute inset-0 w-full h-screen object-cover object-center z-[-2]'
            src={`${process.env.REACT_APP_STATIC_URL}/images/About/Main_Section_Background.jpg`}
            alt='배경'
          />
          <div className='absolute inset-0 w-full h-screen bg-black opacity-15 z-[-1]'/>

          <h1>
            모두가 안심하고 편리한 생활을 누리는<br/>
            건강하고 활기찬 세상을 만듭니다.
          </h1>
        </section>

        <CoreValueStickySection/>

        <section
          data-bg-type='white'
          className="wrapper mt-[120px] lg:mt-[320px]"
        >
          <div className="text-center text-title3 font-bold lg:text-display2 text-label-500">
            효과적인 사업 운영을 위한 조직 구성
          </div>

          <div
            className="
            flex flex-wrap justify-center gap-x-[44px] gap-y-[72px] lg:gap-y-[120px]
            mt-[60px] lg:mt-[140px]
            ">
            {
              TEAM.map((item, idx) => <TeamCard data={item} key={idx}/>)
            }
          </div>
        </section>

        <section
          data-bg-type='white'
          className="wrapper mt-[140px] lg:mt-[320px]"
        >
          <div className='text-center text-title3 font-bold lg:text-display2 text-label-500'>
            우리는 오늘도 성장을 향한 도전을 이어가고 있습니다.
          </div>

          <img
            className='mx-auto mt-[60px]'
            src={`${process.env.REACT_APP_STATIC_URL}/images/About/History_${isMobile ? 'Mobile' : 'Pc'}.png`}
            alt='연혁'
          />
        </section>

        <section className='px-[5%] mt-[140px] lg:mt-[320px]'>
          <div className='text-title3 font-bold lg:text-display2 text-center text-label-500'>
            사업장 방문은 사전 예약 후 방문하여 주시기 바랍니다.
          </div>

          <div className='flex justify-center mt-[60px]'>
            <button
              onClick={() => navigate('/contact?type=reserve')}
              className='w-full py-[16px] lg:w-auto lg:px-[90px] lg:py-[30px] text-heading3 lg:text-title2'>
              방문 예약하기
            </button>
          </div>

          <div
            className="max-w-[1500px] mx-auto lg:flex lg:flex-wrap items-center lg:gap-y-[28px] px-[32px] py-[40px] lg:px-[15%] lg:py-[80px] mt-[100px] lg:mt-[170px] rounded-[16px] lg:rounded-[20px] bg-[#FAFAFA]">
            <p className="lg:w-[20%] text-body1 lg:text-title3 text-label-400">본사</p>
            <p className="lg:w-[80%] mt-[10px] text-body1 lg:text-heading2 text-label-100">경상북도 칠곡군 왜관읍 2산업단지2길 111, 에이동
              2층</p>

            <p className="lg:w-[20%] mt-[32px] lg:mt-0 text-body1 lg:text-title3 text-label-400">연구소</p>
            <p className="lg:w-[80%] mt-[10px] text-body1 lg:text-heading2 text-label-100">경기도 성남시 중원구 양현로 409, 어반스퀘어
              802호</p>

            <p className="lg:w-[20%] mt-[32px] lg:mt-0 text-body1 lg:text-title3 text-label-400">공장</p>
            <p className="lg:w-[80%] mt-[10px] text-body1 lg:text-heading2 text-label-100">경상북도 구미시 산호대로 253, 구미첨단의료기술타워
              912호</p>
          </div>
        </section>

      </main>

      <div className='h-[100px]'/>
      <Footer/>
    </div>
  )
}